export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'auth_access_token',
  REFRESH_TOKEN: 'auth_refresh_token',
  USER: 'auth_user',
  THEME: 'app_theme',
} as const;

export const POINT_RATE = 10; // 1 CNY = 10 points
